<template>
  <div class="function-action-container">
    <div class="event-properties-item">
      <div class="event-label">选择模块</div>
      <div class="list-item">
        <div
          class="function-list-item"
          v-if="changeFunctionModule && changeFunctionModule.value"
        >
          <div class="function-name">{{ changeFunctionModule.name }}</div>
          <div>
            <el-button
              icon="el-icon-delete"
              circle
              title="删除模块"
              size="mini"
              @click="remove"
            ></el-button>
          </div>
        </div>
        <el-button
          icon="el-icon-plus"
          circle
          title="添加消息模块"
          size="mini"
          @click="dialogFunctionShow = true"
        ></el-button>
      </div>
    </div>
    <div></div>
    <div class="event-properties-item">
      <div class="event-label">参数</div>
      <div>
        <el-input size="mini" v-model="params"></el-input>
      </div>
    </div>

    <div>
      <div class="event-properties-addkeyval-header">
        <div class="header-item">key</div>
        <div class="header-item">value</div>
        <div class="header-item">
          <el-dropdown @command="msgCommand">
            <span class="el-dropdown-link">
              添加消息内容<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="module"
                >添加控制模块消息属性</el-dropdown-item
              >
              <el-dropdown-item command="custom"
                >添加自定义属性</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button size="mini" @click="addProp">添加消息内容</el-button> -->
        </div>
      </div>

      <div class="prop-item" v-for="(item, index) in sendMsgList" :key="index">
        <div class="setprops-list">
          <!-- 选择属性 -->
          <el-autocomplete
            class="inline-input"
            v-model="item.key.controlName"
            :fetch-suggestions="querySearch"
            placeholder="选择控制项"
            @select="select($event, item)"
            size="mini"
            v-if="item.type == propCtrType.module"
          ></el-autocomplete>
          <!-- 自定义属性 -->
          <el-input
            size="mini"
            v-model="item.key"
            v-if="item.type == propCtrType.custom"
            placeholder="控制项"
          ></el-input>
        </div>
        <div class="setprops-list">
          <el-input
            size="mini"
            v-model="item.value"
            v-if="
              item.key.showType === moduleType.string ||
              item.type == propCtrType.custom
            "
            placeholder="控制值"
          ></el-input>

          <el-select
            v-model="item.value"
            size="mini"
            placeholder="请选择"
            v-if="item.key.showType === moduleType.enum"
          >
            <el-option
              v-for="item1 in item.key.format"
              :key="item1"
              :label="item1"
              :value="item1"
            >
            </el-option>
          </el-select>

          <el-switch
            v-if="item.key.showType === moduleType.boolean"
            v-model="item.value"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
        <div class="setprops-list">
          <el-button size="mini" @click="removeItem(index)">删除</el-button>
        </div>
      </div>
    </div>

    <FunctionComponent
      :show.sync="dialogFunctionShow"
      @change="confirm"
    ></FunctionComponent>
  </div>
</template>
  <script>
import FunctionComponent from "./function.vue";
const moduleType = {
  boolean: "boolean",
  enum: "enum",
  string: "string",
};

export default {
  components: { FunctionComponent },
  props: {
    uuid: {
      type: String,
      default: "",
    },
    technology: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      moduleType,
      setPropsList: [],
      token: "",
      dialogFunctionShow: false,

      current: -1,
      changeFunctionModule: {
        name: "",
        value: "",
        params: "",
      },
      params: "", //参数
      sendMsgList: [], //发送的消息
      propCtrType: {
        module: 0,
        custom: 1,
      },
    };
  },
  created() {
    this.event = this.technology.getEvent(this.uuid);
    this.DPC = this.$Core.getProvider("DPC");
    this.modules = this.DPC.allModules;

    console.log(this.DPC.originalModulesData);

    this.setMsgFilter();
    this.init();
  },

  destroyed() {
    this.saveConfig();
  },
  methods: {
    msgCommand(Command) {
      if (Command == "module") {
        this.addProp();
      } else if (Command == "custom") {
        let obj = {
          id: this.uuid,
          type: this.propCtrType.custom,
          key: "",
          value: null,
        };
        this.sendMsgList.push(obj);
      }
    },
    // 选择控制项
    select(e, item) {
      item.key = e;
      item.value = null;
    },
    // 设置发送的消息内容
    setMsgFilter() {
      this.setPropsList = this.modules.filter((item) => {
        item.value = item.controlName;
        return (
          item.showType === "boolean" ||
          item.showType === "enum" ||
          item.showType === "string"
        );
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.setPropsList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.controlName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0 ||
          restaurant.key.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    addProp() {
      let obj = {
        id: this.uuid,
        type: this.propCtrType.module,
        key: {},
        value: null,
      };
      this.sendMsgList.push(obj);
    },
    removeItem(index) {
      this.sendMsgList.splice(index, 1);
    },
    saveConfig() {
      if (this.selectFunction) {
        this.event.funcKey = this.selectFunction.key;
        this.event.funcName = this.selectFunction.name;
        this.event.value = this.selectFunction.value;
      }

      if (this.sendMsgList) {
        this.event.msgData = this.sendMsgList;
      }

      this.event.params = this.params;

      // if (!this.changeFunctionModule.value) {
      //   this.event.funcKey = "";
      //   this.event.funcName = "";
      //   this.event.value = "";
      // }
    },
    init() {
      // 显示已选的函数
      this.changeFunctionModule = {
        name: this.event.funcName,
        value: this.event.value,
        params: this.event.params || "",
      };

      if (this.event.msgData) {
        this.sendMsgList = this.event.msgData;
      }

      this.params = this.event.params;
    },

    // 删除函数
    remove() {
      this.changeFunctionModule = {
        name: "",
        value: "",
        params: "",
      };
      this.event.funcKey = "";
      this.event.funcName = "";
      this.event.value = "";
      this.event.params = "";
      this.selectFunction = null;
    },
    confirm(val) {
      if (!val) {
        alert("未选择函数");
        return;
      }
      this.selectFunction = val;
      this.saveConfig();
      this.init();
      this.dialogFunctionShow = false;
    },
  },
};
</script>
  <style lang="scss" scoped>
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .event-label {
    width: 120px;
  }
}
.list-item {
  display: flex;
}
.function-list-item {
  display: flex;
  align-items: center;
  padding-right: 10px;
  .function-name {
    width: 120px;
  }
}
.all-function-module {
  height: 350px;
  overflow-y: auto;
  padding: 10px 15px;
  .function-item {
    cursor: pointer;
    padding: 10px 20px;
    &:hover {
      background: rgba($color: #000000, $alpha: 0.2);
    }
    .name {
      font-size: 20px;
      border-bottom: 1px solid #ddd;
    }
    .desc {
      font-size: 999;
    }
  }
  .select-active {
    background: rgba($color: #000000, $alpha: 0.2);
  }
}
.event-properties-addkeyval-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .header-item {
    flex: 1;
    display: flex;
    align-items: center;
  }
}
.prop-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .setprops-list {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    padding-right: 10px;
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>